import React from 'react';
import './App.css';
import Routes from './routes';
import Login from './components/Page/Login';
import { withRouter } from 'react-router-dom';

class App extends React.Component {
  render() {
    const { location } = this.props;
    if (location && location.pathname === '/login') {
      return <Login />;
    }
    return <Routes />;
  }
}

export default withRouter(App);